module.exports = __webpack_public_path__ + "static/media/product.e0c78faf.svg";